import { balanceModel } from '~/entities/Balance'

export const useRefreshPage = () => {
  const refreshPage = async () => {
    await balanceModel.getPayCardsSilentFx()
  }

  return { refreshPage }
}
